module.exports = __webpack_public_path__ + "img/landing_product_thumbnail-400x300.b9df5485.jpg";